export default __webpack_public_path__ + "static/media/linha-pesada-534x444.72325d58.jpg";